













































import Accent from "@/components/Accent.vue";

export default {
  components: {
    Accent,
  },
};
